import styled from 'styled-components';
import { Grid } from '@attain-sre/attain-design-system';

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CardTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 23px;
  font-family: Calibre-Regular, sans-serif;
`;

export const StyledBodyContainer = styled(Grid)`
  padding: 0px 10px;
`;

export const BodyHeader = styled.div`
  font-size: 18px;
  font-weight: 500;
  font-family: Calibre-Regular, sans-serif;

  & > span {
    color: red;
  }
`;
